// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"457":"86d59224","513":"f6808682","565":"6a44c867","813":"67767319"}[chunkId] + ".chunk.js";
};